import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const slots = {
    header: {
        id: 2747807018,
        style: { display: 'block', minWidth: '120px', maxWidth: '1200px', width: '100%', height: '90px' }
    },
    footer: {
        id: 1203032300,
        style: { display: 'block', minWidth: '120px', maxWidth: '1200px', width: '100%', height: '90px' }
    }
};

const AdSense = (props) => {
    const location = useLocation();
    useEffect(() => {
        try {
            if (location.pathname === '/') return; // redirects
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (e) {
            console.log(e);
        }
    }, [ location.pathname ]);

    const slot = slots[props.slot] || slots.header;
    return (
        <div align="center">
            <ins key={location.pathname} className="adsbygoogle" style={slot.style} data-ad-client="ca-pub-1574398715151725" data-ad-slot={slot.id}></ins>
        </div>
    );
}

export default AdSense;